import { render, staticRenderFns } from "./mailconfigurationEdit.vue?vue&type=template&id=155d2122&"
import script from "./mailconfigurationEdit.vue?vue&type=script&lang=js&"
export * from "./mailconfigurationEdit.vue?vue&type=script&lang=js&"
import style0 from "./mailconfigurationEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports